import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import configs from "@/configs";

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths,
    mode: 'history'
});
// router gards
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            let user = JSON.parse(localStorage.getItem('user'))
            const role_type = _.find(configs.ROLES, {'value': user.role})
            if(role_type && (role_type.modules & to.meta.roleId)){
                next()
            }
            else {
                next({
                    path: '/'
                })
            }
        }
    } else if (to.matched.some(record => record.meta.public)) {
        if (localStorage.getItem('jwt') == null) {
            next()
        }
        else {
            next({
                path: '/'
            })
        }
    } else {
        next()
    }
    Vue.nextTick(() => {
        document.title = to.meta.title ? to.meta.title + (to.params.Pid ? ' #' + to.params.Pid : '') + ' | ' + configs.DEFAULT_TITLE : configs.DEFAULT_TITLE;
    });
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
